module.exports = __webpack_public_path__ + "static/Flavor_18AMT90224-1b293dfa0ae5a0a4793589b3a60774d3.pdf";